import { useMutation, useQueryClient } from "@tanstack/react-query"

import { fetchDeliverable } from "@/hooks/api/deliverables/api"
import { useApiContext } from "@/hooks/api/use-api-context"

import { createPersonalDeliverableTemplate } from "./api"

export function useSavePersonalDeliverableTemplate() {
  const context = useApiContext()
  const client = useQueryClient()
  return useMutation({
    mutationFn: async ({ name, deliverableId }: { name: string; deliverableId: string }) => {
      const api = await context()
      const latest = await fetchDeliverable(api, deliverableId)
      return createPersonalDeliverableTemplate(api, {
        name,
        deliverable_id: deliverableId,
        editor_revision: latest.editor_revision,
      })
    },
    onSuccess: () => client.invalidateQueries({ queryKey: ["personal-deliverable-templates"] }),
  })
}
